import React from 'react';
import { ListItem, ListItemText, ListItemAvatar, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Error, Cancel, Done, DoneAll, SpeakerNotesOff, Info } from '@material-ui/icons';
import DescriptionList from './DescriptionList';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import { CONSTANTS } from '../../../../../constants/constants';

const useStyles = makeStyles((theme) => ({
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  red: {
    backgroundColor: '#B00020'
  },
  green: {
    backgroundColor: '#0DC599'
  } }));

const ListItemAvatarCustom = ({ currentStatus, documentStatus }) => {
  const classes = useStyles();
  if (currentStatus === CONSTANTS.BUNDLE.STATUS.ERROR) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <Error />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.CANCELLED && documentStatus === CONSTANTS.DOCUMENT.STATUS.CANCELLED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <Cancel />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.SIGNED && documentStatus === CONSTANTS.DOCUMENT.STATUS.CANCELLED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.yellow}>
          <Cancel />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.REJECTED && documentStatus === CONSTANTS.DOCUMENT.STATUS.REJECTED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.yellow}>
          <SpeakerNotesOff />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.SIGNED && documentStatus === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <Done />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.READY) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <Done />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.BUNDLE.STATUS.SIGNED && documentStatus === CONSTANTS.DOCUMENT.STATUS.SIGNED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green} >
          <DoneAll />
        </Avatar>
      </ListItemAvatar>
    );
  } else {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <Info />
        </Avatar>
      </ListItemAvatar>
    );
  }
};

const BundleItem = ({ notif, markAsRead, data }) => {
  const classes = useStyles();
  const currentStatus = data.step ? data.step.status : data.bundle ? data.bundle.status : undefined;
  const currentStepType = data.step ? data.step.type : undefined;
  const documentStatus = data.bundle ? data.bundle.status : currentStatus;
  const documentName = data.bundle.name;

  return (
    <ListItem
      alignItems='flex-start'
      onClick={markAsRead.bind(null, notif.id)}
      key={notif.id}
      divider
      className={classes.listItem}
    >
      <ListItemAvatarCustom
        currentStatus={currentStatus}
        documentStatus={documentStatus}
      />
      <ListItemText
        primary={documentName}
        secondary={
          <React.Fragment>
            <DescriptionList
              notif={notif}
              currentStatus={currentStatus}
              documentStatus={documentStatus}
              documentName={documentName}
              currentStepType={currentStepType}
            />
            <br />
            <Moment
              format='DD/MM/YYYY HH:mm:ss'
              style={{ fontSize: '0.8em' }}
            >
              {notif.createdAt}
            </Moment>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

BundleItem.propTypes = {
  notif: PropTypes.object,
  markAsRead: PropTypes.func,
  data: PropTypes.object
};

export default BundleItem;
